import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    meta: {
      title: "晟煜防伪码验证",
    },
    component: () => import("@/views/sySecurity.vue"),
  },
  {
    path: "/security/sy",
    meta: {
      title: "晟煜防伪码验证",
    },
    component: () => import("@/views/sySecurity.vue"),
  },
  {
    path: "/security/storeList",
    meta: {
      title: "授权店铺列表",
    },
    component: () => import("@/views/storeList.vue"),
  },
  {
    path: "/security/storeDetail",
    meta: {
      title: "店铺详情",
    },
    component: () => import("@/views/storeDetail.vue"),
  },

  {
    path: "/security/result",
    meta: {
      title: "验证结果",
    },
    name: "s-result",
    component: () => import("@/views/result.vue"),
  },
  {
    path: "/security/input",
    meta: {
      title: "防伪码验证",
    },
    component: () => import("@/views/inputSecurity.vue"),
  },
  {
    path: "/security/productList",
    meta: {
      title: "商品列表",
    },
    component: () => import("@/views/productList.vue"),
  },
  {
    path: "/security/productDetail",
    meta: {
      title: "商品详情",
    },
    component: () => import("@/views/productDetail.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",

  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
    next();
  }
});

export default router;
